export default function () {
  if (this.$route.name === 'EditBlogCategory') {
    this.loadCategory()
  }
}
